import React from "react";
import { Link } from "react-router-dom";
export default function Header(){
    return(
        <header className="relative py-[10px] shadow-md">
            <div className="container flex items-center justify-between">
                <div>
                    <img className="w-[100%] h-[65px]" src={require("../../assets/logo/logo.png")} alt="" />
                </div>
                <Link className="bg-[#294A6A] px-[30px] py-[8px] rounded-[4px] text-white capitalize transition duration-500 hover:bg-[#273b4f]" to={"/"}>go to website</Link>
            </div>
        </header>
    );
}